import { getApiLanguage } from "../i18n/apiLanguage.ts";

export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const request = new Request(input, { ...init, credentials: "include" });
    const language = getApiLanguage();

    if (language) {
        request.headers.set("Accept-Language", language);
    }

    const response = await fetch(request);

    if (response.ok) {
        const contentType = response.headers.get("content-type");
        const mediaType = contentType?.toLowerCase();

        if (mediaType && !mediaType.includes("application/json") && !mediaType.includes("text/event-stream")) {
            throw new Error(`Unexpected non-JSON API response (${contentType}) with status ${response.status} from ${response.url}. The API is unreachable or, on the MSW preview, the service worker did not intercept this request.`);
        }
    }

    return response;
}
